export default __webpack_public_path__ + "84269ddc1b6ccfcebebfa7a4a2fdd78c.webp";